import { render } from "./ReportSummary.vue?vue&type=template&id=54b0b0e6&scoped=true"
import script from "./ReportSummary.vue?vue&type=script&lang=js"
export * from "./ReportSummary.vue?vue&type=script&lang=js"

import "./ReportSummary.vue?vue&type=style&index=0&id=54b0b0e6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54b0b0e6"]])

export default __exports__